define('lib/shim/gsap',['vendor/gsap/lib', 'vendor/gsap/plugins/ScrollToPlugin'], function () {
  return {
    TweenMax: window.TweenMax,
    TimelineMax: window.TimelineMax,
  };
});

